<div class="report-table">
  <sc-sub-title *ngIf="hasTitleDictionaryKey()" >
    <sc-dictionary-label [dictionaryKey]="titleDictionaryKey"></sc-dictionary-label>
  </sc-sub-title>
  <sc-sub-title *ngIf="!hasTitleDictionaryKey() && hasTitle()" >{{title}}</sc-sub-title>
  <sc-content-spacer vertical></sc-content-spacer>
  <table class="{{classes}}">
    <thead *ngIf="!hideHeaders">
      <tr>
        <th style="width: 200px"></th><th *ngFor="let column of columns" [ngStyle]="{'min-width': columnWidth}">
          <ng-container *ngIf="hasDictionaryLabel(column)">
            <sc-dictionary-label [dictionaryKey]="column.dictionaryKey"></sc-dictionary-label>
          </ng-container>
          <ng-container *ngIf="!hasDictionaryLabel(column)">
            {{column.label}}
          </ng-container>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of rows; let i = index" >
        <td>
          <sc-dictionary-label [dictionaryKey]="row.dictionaryKey"></sc-dictionary-label>
        </td>
        <td *ngFor="let column of columns" class="text-right" [ngStyle]="{'min-width': columnWidth}">{{value(i, column.key)}}</td>
      </tr>
    </tbody>


  </table>


</div>
